import React, {useState} from 'react';
import {toast} from "react-toastify";
import Button from "../../../../components/common/Button";
import ConfirmDialog from "../../../../components/ConfirmDialog";
import FetchService from "../../../../services/api/FetchService";
import {ErrorToastSettings, SuccessToastSettings} from "../../../../services/toast/toastSettings";
import styles from './styles.module.scss';

interface IProps {
    companyId: number;
    checklistId: number;
    isApproved: boolean;
    onApproved: () => void;
}

const ApproveChecklistButton: React.FC<IProps> = ({companyId, checklistId, isApproved, onApproved}) => {
    const [isDialogOpen, setIsDialogOpen] = useState<boolean>(false);
    const [isLoading, setIsLoading] = useState<boolean>(false);

    if (isApproved) return null;

    const handleConfirmApprove = async () => {
        try {
            setIsLoading(true);
            await FetchService.postChecklistManagementApprove(companyId, checklistId);
            toast.success('Чеклист затверджено', SuccessToastSettings);
            setIsDialogOpen(false);
            onApproved();
        } catch (error) {
            toast.error('Не вдалося затвердити чеклист', ErrorToastSettings);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <>
            <div className={styles.approveBtn}>
                <Button
                    text={'Затвердити'}
                    onClick={() => setIsDialogOpen(true)}
                />
            </div>
            <ConfirmDialog
                open={isDialogOpen}
                title={'Затвердити чеклист?'}
                text={'Після затвердження редагування питань буде недоступне. Ви впевнені, що хочете затвердити цей чеклист?'}
                confirmText={'Затвердити'}
                isLoading={isLoading}
                onConfirm={handleConfirmApprove}
                onCancel={() => setIsDialogOpen(false)}
            />
        </>
    );
};

export default ApproveChecklistButton;
